<div edsRow>
  <div
    edsPadding
    edsSpacing="md"
    [edsPaddingLeft]="(isHandheld$ | async) ? 'md' : 'xxl'"
    [edsPaddingRight]="(isHandheld$ | async) ? 'md' : 'xxl'"
    edsSpacing="lg"
  >
    <eds-proximal placement="RegulatoryFundDocumentTop"></eds-proximal>
    <eds-dynamic-table
      *ngIf="rowData.length"
      [colDefs]="colDefs"
      [rowData]="rowData"
      [rowTemplate]="regulatoryDocumentTemplate"
      [mobileTemplate]="regulatoryDocumentMobileTemplate"
      tableTheme="secondary"
      [cardBreakpoint]="FrkBreakpoint.Tablet"
      [showPagination]="false"
      [padding]="'md'"
    ></eds-dynamic-table>
    <eds-proximal placement="RegulatoryFundDocumentBottom"></eds-proximal>
  </div>
</div>
<ng-template #regulatoryDocumentTemplate let-item>
  <tr class="dynamic-table__tr dynamic-table__tr--has-borders">
    <td
      class="dynamic-table__td dynamic-table__td--padding-md dynamic-table__td--fund-name"
    >
      <span tabindex="0">{{ item.fundName }}</span>
    </td>
    <td
      class="dynamic-table__td dynamic-table__td--share-class {{
        item?.shareclassOption ? 'dynamic-table__td--padding-md' : ''
      }}"
    >
      <eds-flyout-menu-initial-v2
        *ngIf="item?.flyoutMetaData?.items?.length > 1"
        [widthSize]="'xl'"
        [title]="item.selectedShareclass"
        [flyoutMetaData]="item.flyoutMetaData"
        [leftSpacingZero]="true"
        [topSpacingZero]="true"
        ariaLabelledby="languages"
      ></eds-flyout-menu-initial-v2>
      <span tabindex="0" *ngIf="item?.flyoutMetaData?.items?.length === 1">{{
        item?.flyoutMetaData?.items[0].link
      }}</span>
      <span tabindex="0" *ngIf="item?.flyoutMetaData?.items?.length === 0">{{
        EMDASH
      }}</span>
    </td>

    <td
      class="dynamic-table__td dynamic-table__td--padding-md"
      *ngFor="let docyType of colDefs.slice(2, -1)"
    >
      <a
        *ngIf="
          item?.docs !== undefined && item?.docs[docyType?.field] !== undefined;
          else notAvailable
        "
        (click)="openDocument(item?.docs[docyType?.field])"
      >
        <eds-icon
          tabindex="0"
          type="pdf"
          addTitle="{{ item.fundName }} {{ docyType?.field }}"
        >
        </eds-icon
      ></a>
    </td>
    <td class="dynamic-table__td dynamic-table__td--padding-md">
      <a href="{{ item?.viewMoreHref }}" target="_blank">{{
        "literature.view-more" | translate
      }}</a>
    </td>
  </tr>
</ng-template>
<!-- Mobile view -->
<ng-template #regulatoryDocumentMobileTemplate let-item>
  <div>
    <eds-panel edsSpacing="md" [hasBorders]="true">
      <div edsSpacing="md" edsPadding edsPaddingLeft="md" edsPaddingTop="md">
        {{ item.fundName }}
      </div>
      <div edsSpacing="md">
        <div edsFlexbox flexDirection="row">
          <div edsPadding edsPaddingLeft="md" edsPaddingTop="sm">
            {{ "literature.share-class" | translate }}
          </div>
          <div>
            <eds-flyout-menu-initial-v2
              *ngIf="item?.flyoutMetaData?.items?.length > 1"
              [widthSize]="'sm'"
              [title]="item.selectedShareclass"
              [flyoutMetaData]="item.flyoutMetaData"
              ariaLabelledby="languages"
            ></eds-flyout-menu-initial-v2>
            <div
              edsPadding
              edsPaddingLeft="md"
              edsPaddingTop="sm"
              *ngIf="item?.flyoutMetaData?.items?.length === 1"
            >
              {{ item?.flyoutMetaData?.items[0].link }}
            </div>
            <div
              edsPadding
              edsPaddingLeft="md"
              edsPaddingTop="sm"
              *ngIf="item?.flyoutMetaData?.items?.length === 0"
            >
              {{ EMDASH }}
            </div>
          </div>
        </div>
      </div>
      <ng-container>
        <div edsSpacing="md" *ngFor="let docyType of colDefs.slice(2, -1)">
          <div edsGrid>
            <div edsRow>
              <div edsCol [columnNumbers]="{ s: 2, m: 4 }">
                {{ docyType?.headerName }}
              </div>
              <div edsCol [columnNumbers]="{ s: 2, m: 4 }">
                <a
                  *ngIf="
                    item?.docs !== undefined &&
                      item?.docs[docyType?.field] !== undefined;
                    else notAvailable
                  "
                  (click)="openDocument(item?.docs[docyType?.field])"
                >
                  <eds-icon
                    type="pdf"
                    [addTitle]="'literature.pdf-icon' | translate"
                  >
                  </eds-icon
                ></a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div edsPadding edsSpacing="md" edsPaddingLeft="md" edsPaddingTop="md">
        <a href="{{ item?.viewMoreHref }}" target="_blank">
          {{ "literature.view-more" | translate }}</a
        >
      </div>
    </eds-panel>
  </div>
</ng-template>

<ng-template #notAvailable>
  <span tabindex="0">{{ "literature.NA" | translate }}</span>
</ng-template>
